<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
      <v-card-text>
        <v-layout column>
          <v-flex v-html="text">
        </v-flex>
        <v-layout row wrap>
        <v-flex>
          <v-text-field
            label="Номер договора"
            hint=""
            v-model="agreementNumber"
            :rules="[v=>!!v || 'номер должен быть указан']"                        
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Срок действия по"
            :rules="[]"
            hint=""
            v-model="item.expiryTime"
          >
          </v-date-field>
        </v-flex>
        </v-layout>
        <v-layout row>
        <v-flex xs6>
          <v-text-field
            label="Вы являетесь"
            hint=""
            v-model="clientRole"
            clearable
            :rules="[v=>!!v || 'например: Стороной 1']"                        
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            label="Партнер является"
            :rules="[v=>!!v || 'например: Стороной 2']"                        
            hint=""
            clearable
            v-model="partnerRole"
          >
        </v-text-field>  
        </v-flex>
        </v-layout>
        
        <v-flex>
          <v-text-field
            prepend-icon="attach_file"
            @click:prepend="dialogOpen"
            label="Ссылка на документ"
            clearable
            hint=""
            v-model="item.link"
            :rules="[v=>!!v || 'cсылка должна быть указана']"            
          ></v-text-field>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-form>
    <template #actions>
      <v-btn :disabled="!valid" @click="add">Направить</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import depo from '../depo'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'post-offer-form',
    components: {vDateField, vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      clientRole: '',
      partnerRole: ''
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        chat: 'getChatterChat',
        profile: 'getProfile',
        getDepoUrl: 'getDepoUrl'
      }),
      partnerName () {
        return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]'
      },
      partnerInn () {
        return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]'
      },
      clientName () {
        return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]'
      },
      clientInn () {
        return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]'
      },
      expiryTime () {
        return this.item.expiryTime ? 'Срок действия настоящей оферты по ' + formats.formatDate(moment(this.item.expiryTime)) + '.' : ''
      },
      docLink () {
        return this.item.link ? this.item.link : ''
      },
      title () {
        return 'Направить оферту'
      },
      text: {
        get () {
          return this.getText()
        }
      }
    },
    methods: {
      add () {
        if (this.$refs.form.validate()) {
          this.item.text = this.getText()
          this.item.chatId = this.chat.id
          this.$store.dispatch('addChatterPost', this.item)
          this.edit = false
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          chatId: null,
          text: '',
          typeCode: 'OFFER',
          expiryTime: moment().add(5, 'days').format(),
          link: null
        }
      },
      getText () {
        return `${this.clientName}, ИНН ${this.clientInn} предлагает ${this.partnerName}, ИНН ${this.partnerInn} заключить договор № ${this.agreementNumber} на условиях, указанных в файле по адресу: <a href="${this.docLink}">${this.docLink}</a>, где ${this.clientName}  является ${this.clientRole}, а ${this.partnerName} - ${this.partnerRole}. ${this.expiryTime} Для принятия настоящей оферты достаточно нажать кнопку "Акцепт"`
      },
      setDoc: function (value) {
        var docLink = this.getDepoUrl(value)
        this.item.link = docLink
      },
      dialogOpen: function () {
        depo.selectDoc(this, this.setDoc)
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PostOfferForm.vue?17658490